import { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'

/**
 * Estrutura persistente do app: navegação sempre visível no desktop
 * (reconhecimento em vez de memorização) e drawer no mobile.
 */
export function AppShell() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()

  // Fecha o menu ao navegar — evita o drawer ficar aberto sobre a nova tela.
  useEffect(() => {
    setMobileNavOpen(false)
  }, [location.pathname])

  // Atalho de teclado: "c" cria uma publicação (heurística #7).
  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if (event.metaKey || event.ctrlKey || event.altKey) return
      const target = event.target as HTMLElement | null
      const typing =
        target &&
        (target.tagName === 'INPUT' ||
          target.tagName === 'TEXTAREA' ||
          target.tagName === 'SELECT' ||
          target.isContentEditable)
      if (typing) return

      if (event.key === 'c') {
        event.preventDefault()
        navigate('/criar')
      }
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [navigate])

  return (
    <div className="min-h-screen bg-[var(--surface-app)]">
      <a href="#conteudo" className="sh-skip-link">
        Pular para o conteúdo
      </a>

      <Sidebar open={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />

      <div className="lg:pl-64">
        <Topbar onOpenNav={() => setMobileNavOpen(true)} />

        <main id="conteudo" tabIndex={-1} className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
